
import { Vue, Component, Prop } from 'vue-property-decorator';

/**
 * Collapses a chart's option toggles behind a single "Options" button in the
 * filterable's `topRight` slot, keeping the card header clean.
 *
 * The caller owns the contents, so the existing settingx-bound toggles keep
 * working unchanged; group them with <b-dropdown-header> / <b-dropdown-divider>:
 *
 *   <template v-slot:topRight>
 *       <ChartOptionsDropdown>
 *           <b-dropdown-header>Document Type</b-dropdown-header>
 *           <IncludeCreditNoteToggle></IncludeCreditNoteToggle>
 *           <b-dropdown-divider></b-dropdown-divider>
 *           <b-dropdown-header>Amount</b-dropdown-header>
 *           <IncludeTaxToggle></IncludeTaxToggle>
 *       </ChartOptionsDropdown>
 *   </template>
 *
 * Deliberately mirrors filters/ListFilter.vue (same b-dropdown shell, no-caret,
 * btn-filter toggle, default button size) so it reads like the global filters.
 * `.btn-filter` and `.scrollable-menu` are declared in ListFilter's un-scoped
 * style block, which every page loads via its filter bar.
 */
@Component
export default class ChartOptionsDropdown extends Vue {
	@Prop({ default: 'Options' }) public readonly label!: string;
	@Prop({ default: 'fa fa-sliders-h' }) public readonly iconClass!: string;
	@Prop({ default: '14rem' }) public readonly menuMinWidth!: string;
}
